<div
  [ngClass]="
    notification.readDate && notification.readDate! >= notification.notificationDate!
      ? 'notification-card notification-card-read'
      : 'notification-card'
  "
  class="fxl-column"
>
  <div class="whole-width fxl-row fxla-space-between-center">
    <div [ngClass]="'notification-title ' + notification.colorClass" class="fxl-row fxg-row-8px">
      @if (notificationIcon.startsWith('svg')) {
        <mat-icon class="s-16" svgIcon="{{ notificationIcon }}"></mat-icon>
      }
      @if (!notificationIcon.startsWith('svg')) {
        <mat-icon class="s-16">{{ notificationIcon }}</mat-icon>
      }
      <span>{{ notification.title }}</span>
    </div>

    <button (click)="onCloseClickedHandler()" class="close-button" mat-icon-button>
      <mat-icon class="primary-fg s-16">close</mat-icon>
    </button>
  </div>
  <div class="notification-content">
    <span>{{ notification.messageLine1 }}</span>
    <div>
      <ng-content select="[notification-content]"></ng-content>
    </div>
  </div>
</div>
